


























































































// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator';
import { Booking, ApiError, Lot, User, LotRegion } from '@/api';
import { apiBase, apiNamespace } from '@/config';
import { snackModule, authModule } from '@/store';
import { Route } from 'vue-router';
import ConfirmDialog from '@/components/admin/ConfirmDialog.vue';
import DatePicker from '@/components/DatePicker.vue';
import RelAutocomplete from '@/components/RelAutocomplete.vue';

@Component({
  components: {
    ConfirmDialog,
    DatePicker,
    RelAutocomplete,
  },
})
export default class extends Vue {
  @Prop({ required: false }) readonly routeTitle: string;

  loading: boolean = false;
  valid: boolean = false;
  complete: boolean = false;
  error: string = '';

  booking: Booking | null = null;

  nextFn: (() => void) | null = null;
  leaveConfirmDialog: boolean = false;
  confirmLeaveContent: string =
    'Are you sure you would like to leave? Any unsaved changes will be lost.';

  requiredString = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'This field is required',
  ];

  requiredObject = [
    (v: Lot) => {
      if (!v) {
        return 'This field is required';
      }

      return (
        v8n()
          .string()
          .not.empty()
          .test(v.id) || 'This field is required'
      );
    },
  ];

  get bookingId() {
    return this.$route.params.bookingId;
  }

  get invoiceUrl() {
    return apiBase + apiNamespace + '/bookings/' + this.bookingId + '/invoice/';
  }

  back() {
    this.$router.back();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    if (this.booking && this.booking.isDirty()) {
      this.nextFn = next;
      this.leaveConfirmDialog = true;
      next(false);
    } else {
      next();
    }
  }

  leave() {
    if (this.nextFn) {
      this.nextFn();
    }
  }

  get regionRowOptions() {
    if (!this.booking || !this.booking.lotRegion) {
      return;
    }
    const rowsNumber = this.booking.lotRegion.rows;
    const rows = [];

    for (let index = 0; index < rowsNumber; index++) {
      const value = 'Row ' + (index + 1);
      rows.push({
        text: value,
        value: index + 1,
      });
    }
    return rows;
  }

  staffScopeFactory() {
    return User.includes(['customer']);
  }

  get staffWhere() {
    return { staff: true };
  }

  lotScopeFactory() {
    return Lot.includes([]);
  }

  lotRegionScopeFactory() {
    return LotRegion.includes([]);
  }

  get lotRegionWhere() {
    if (!this.booking || !this.booking.lot) {
      return;
    }
    return { lot: this.booking.lot.id };
  }

  async save() {
    if (!this.booking) {
      return;
    }

    try {
      await this.booking.save({
        with: ['lot.id', 'lotRegion.id', 'parkedBy.id'],
      });
      snackModule.showSnackbar('Booking Updated');
    } catch (err) {
      err.response.errors.forEach((e: ApiError) =>
        snackModule.showSnackbar(e.detail),
      );
    }
  }

  async mounted() {
    try {
      this.booking = (await Booking.find(this.bookingId)).data;
    } catch (err) {
      // most likely this means not found
      snackModule.showSnackbar('Booking not found');
    }
  }
}
